export function projectPmsLogo(index: number, count: number, angle: number) {
  // Fibonacci distribution keeps logos evenly spaced on a rotating sphere.
  const y = 1 - 2 * (index + 0.5) / count;
  const radius = Math.sqrt(1 - y * y);
  const longitude = index * Math.PI * (3 - Math.sqrt(5)) + angle;
  const x = Math.cos(longitude) * radius;
  const z = Math.sin(longitude) * radius;
  const tilt = 0.16;
  const tiltedY = y * Math.cos(tilt) - z * Math.sin(tilt);
  const depth = y * Math.sin(tilt) + z * Math.cos(tilt);
  const perspective = 3.8 / (3.8 - depth);
  return {
    x: 50 + x * 35 * perspective,
    y: 50 + tiltedY * 35 * perspective,
    scale: 0.72 + (depth + 1) * 0.2,
    opacity: 0.24 + (depth + 1) * 0.38,
    zIndex: Math.round((depth + 1) * 50),
  };
}
